import React, { useEffect } from 'react';
import Image from './Image';
import { useSelector, useDispatch } from 'react-redux';
import GenericButton from './GenericButton';
import Step from './Step';
import TreatmentStep from './TreatmentStep';
import {
    setEspotBackground,
    setEspotBackgroundTreatment,
    setIsMade,
    setFiveSecond,
    setControlVideo,
    setPercentageProgress,
    setContentOnLoad,
    setFullscreen,
    setTapAndHold,
    setEspotBackgroundTap,
    setEspotBackgroundTreatmentTap,
    setStepValueSelected,
    setMyVideoTime,
    setIsFirstVideo,
    setEspotBackgroundVideo,
} from '../app/mainSlice';
import { isMobile } from 'react-device-detect';
import Slider from 'react-slick';
import ClickNHold from '../ext/ClickNHold.jsx';

/**
 * @param props.isOpen
 * @param props.closeModal
 * @param props.step
 * @param props.renderStepContent
 * @param props.firstLearnMoreStep
 * @param props.treatmentType
 * @param props.treatmentGroup
 * @param props.config
 *
 */
const LearnMoreModal = props => {
    const dispatch = useDispatch();
    const labels = useSelector(state => state.main.labels);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const data = useSelector(state => state.main.data);
    let firstLearnMoreTreatment = {};
    let firstLearnMoreTreatmentMobile = {};
    const stepValueSelected = useSelector(state => state.main.stepValueSelected);
    const espotBackground = useSelector(state => state.main.espotBackground);
    const espotBackgroundTreatment = useSelector(state => state.main.espotBackgroundTreatment);
    const currentStep = useSelector(state => state.main.currentStep);
    const myVideoRef = React.useRef();
    const myVideoRefTap = React.useRef();
    const myVideoRefBackground = React.useRef();
    const isMade = useSelector(state => state.main.isMade);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const fiveSecond = useSelector(state => state.main.fiveSecond);
    const controlVideo = useSelector(state => state.main.controlVideo);
    const percentageProgress = useSelector(state => state.main.percentageProgress);
    const learnMoreBackgrounds = useSelector(state => state.main.learnMoreBackgrounds);
    const contentOnLoad = useSelector(state => state.main.contentOnLoad);
    const fullscreen = useSelector(state => state.main.fullscreen);
    const tapAndHold = useSelector(state => state.main.tapAndHold);
    const espotBackgroundTap = useSelector(state => state.main.espotBackgroundTap);
    const espotBackgroundTreatmentTap = useSelector(
        state => state.main.espotBackgroundTreatmentTap
    );
    const myVideoTime = useSelector(state => state.main.myVideoTime);
    let first = true;
    const isFirstVideo = useSelector(state => state.main.isFirstVideo);
    const espotBackgroundVideo = useSelector(state => state.main.espotBackgroundVideo);

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        centerMode: true,
        centerPadding: '45px',
        focusOnSelect: true,
        arrow: false,
        beforeChange: function (current, next) {
            if (
                props.firstLearnMoreStep[next + 1] &&
                props.firstLearnMoreStep[next + 1].current !== null
            ) {
                props.firstLearnMoreStep[next + 1].current.click();
            } else if (
                firstLearnMoreTreatmentMobile[next + 1] !== undefined &&
                firstLearnMoreTreatmentMobile[next + 1].current !== null
            ) {
                firstLearnMoreTreatmentMobile[next + 1].current.click();
            }
        },
    };

    //Set first step button focus
    useEffect(() => {
        if (props.isOpen) {
            setTimeout(() => document.querySelector('.step-button-selected')?.focus(), 500);
            setTimeout(() => document.querySelector('.step-radio-button')?.focus(), 500);
        }
    }, [props.isOpen]);

    useEffect(() => {
        if (isLearnMoreModalOpen) {
            if (props.step === 'thickness' && isMade) {
                if (
                    myVideoRef.current &&
                    myVideoRef.current.children[0] !== undefined &&
                    myVideoRef.current.children[0].children[0] !== undefined &&
                    myVideoRef.current.children[0].children[0].tagName === 'VIDEO'
                ) {
                    dispatch(
                        setMyVideoTime(myVideoRef.current.children[0].children[0].currentTime)
                    );
                } else {
                    dispatch(setMyVideoTime(null));
                }
            } else {
                dispatch(setMyVideoTime(null));
                dispatch(setEspotBackgroundVideo(null));
            }
            dispatch(setEspotBackground(null));
            dispatch(setEspotBackgroundTreatment(null));
            dispatch(setEspotBackgroundTap(null));
            dispatch(setEspotBackgroundTreatmentTap(null));

            let espotName = '';

            if (!props.treatmentType) {
                if (data.content[props.step][stepValueSelected[props.step]].contentIdentifier) {
                    espotName =
                        data.content[props.step][stepValueSelected[props.step]].contentIdentifier;
                } else if (data.content[props.step][stepValueSelected[props.step]].espotName) {
                    espotName = data.content[props.step][stepValueSelected[props.step]].espotName;
                }
            } else {
                if (
                    data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                        .contentIdentifier
                ) {
                    espotName =
                        data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                            .contentIdentifier;
                } else if (
                    data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                        .espotName
                ) {
                    espotName =
                        data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                            .espotName;
                }
            }

            if (isMobile) {
                espotName = 'MOB_' + espotName;
            } else {
                espotName = 'DESK_' + espotName;
            }

            let allEspotName = espotName + (isMade ? '-made' : '-treatment');
            if (learnMoreBackgrounds)
                dispatch(setContentOnLoad(learnMoreBackgrounds[allEspotName]));

            props.config.actionsModule.loadLearnMoreContent(espotName).then(content => {
                //prendere gli id e inserire i dati
                //split per tutti i vari div
                //switchare per la classe e poi caricare il tutto
                let espotVideoMade = null;
                let espotVideoMadeTap = null;
                let espotVideoTreatment = null;
                let espotVideoTreatmentTap = null;
                let contentArray = content.split('</div>');
                for (let i = 0; i < contentArray.length - 1; i++) {
                    contentArray[i] += '</div>';
                    let id = contentArray[i].split('class="')[1].split('"')[0];
                    switch (id) {
                        case 'background-learn-more-made':
                            espotVideoMade = contentArray[i];
                            break;
                        case 'background-learn-more-treatment':
                            espotVideoTreatment = contentArray[i];
                            break;
                        case 'background-learn-more-made-tap':
                            espotVideoMadeTap = contentArray[i];
                            break;
                        case 'background-learn-more-treatment-tap':
                            espotVideoTreatmentTap = contentArray[i];
                            break;
                    }
                }

                if (props.step === 'thickness' && isMade && !espotBackgroundVideo)
                    dispatch(setEspotBackgroundVideo(espotVideoMade));

                dispatch(setEspotBackground(espotVideoMade));
                dispatch(setEspotBackgroundTreatment(espotVideoTreatment));
                dispatch(setEspotBackgroundTap(espotVideoMadeTap));
                dispatch(setEspotBackgroundTreatmentTap(espotVideoTreatmentTap));
                if (!(props.step === 'thickness') || (props.step === 'thickness' && !isMade)) {
                    dispatch(setControlVideo(null));
                }
                dispatch(setFiveSecond(false));
                dispatch(setIsMade(true));
                dispatch(setTapAndHold(null));

                if (
                    myVideoRefBackground.current &&
                    myVideoRefBackground.current.children[0] !== undefined &&
                    myVideoRefBackground.current.children[0].children[0] !== undefined &&
                    myVideoRefBackground.current.children[0].children[0].tagName === 'VIDEO'
                ) {
                    let myVideoBack = myVideoRefBackground.current.children[0].children[0];
                    myVideoBack.pause();
                }
            });
        }
    }, [stepValueSelected]);

    useEffect(() => {
        if (isLearnMoreModalOpen) {
            //First Selected
            if (!props.treatmentType) props.firstLearnMoreStep[1].current.click();
            else {
                if (firstLearnMoreTreatment[1]) {
                    if (
                        firstLearnMoreTreatment[1].current.className.indexOf(
                            'included-selection'
                        ) !== -1
                    ) {
                        dispatch(
                            setStepValueSelected({
                                [props.treatmentType]: firstLearnMoreTreatment[1].current.id,
                            })
                        );
                        firstLearnMoreTreatment[1].current.className =
                            firstLearnMoreTreatment[1].current.className + ' selected';
                    } else {
                        firstLearnMoreTreatment[1].current.click();
                    }
                }
                if (firstLearnMoreTreatmentMobile[1])
                    if (
                        firstLearnMoreTreatmentMobile[1].current.className.indexOf(
                            'included-selection'
                        ) !== -1
                    ) {
                        dispatch(
                            setStepValueSelected({
                                [props.treatmentType]: firstLearnMoreTreatmentMobile[1].current.id,
                            })
                        );
                        firstLearnMoreTreatmentMobile[1].current.className =
                            firstLearnMoreTreatmentMobile[1].current.className + ' selected';
                    } else {
                        firstLearnMoreTreatmentMobile[1].current.click();
                    }
            }
        }
    }, [isLearnMoreModalOpen]);

    useEffect(() => {
        if (isLearnMoreModalOpen) {
            let espotName = '';

            if (!props.treatmentType) {
                if (data.content[props.step][stepValueSelected[props.step]].contentIdentifier) {
                    espotName =
                        data.content[props.step][stepValueSelected[props.step]].contentIdentifier;
                } else if (data.content[props.step][stepValueSelected[props.step]].espotName) {
                    espotName = data.content[props.step][stepValueSelected[props.step]].espotName;
                }
            } else {
                if (
                    data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                        .contentIdentifier
                ) {
                    espotName =
                        data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                            .contentIdentifier;
                } else if (
                    data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                        .espotName
                ) {
                    espotName =
                        data.content[props.treatmentType][stepValueSelected[props.treatmentType]]
                            .espotName;
                }
            }

            if (isMobile) {
                espotName = 'MOB_' + espotName;
            } else {
                espotName = 'DESK_' + espotName;
            }

            let allEspotName = espotName + (isMade ? '-made' : '-treatment');
            if (learnMoreBackgrounds)
                dispatch(setContentOnLoad(learnMoreBackgrounds[allEspotName]));

            if (myVideoRef.current.children[0]) {
                let myVideo = myVideoRef.current.children[0].children[0];
                if (myVideo) {
                    myVideo.addEventListener('ended', videoEnded);
                    myVideo.addEventListener('timeupdate', timeUpdate);
                    if (props.step === 'thickness' && isMade)
                        myVideo.addEventListener('play', videoStart);
                    dispatch(setIsFirstVideo(!isFirstVideo));
                }
            }

            if (myVideoTime && isMade) {
                if (
                    myVideoRef.current &&
                    myVideoRef.current.children[0] !== undefined &&
                    myVideoRef.current.children[0].children[0] !== undefined &&
                    myVideoRef.current.children[0].children[0].tagName === 'VIDEO'
                ) {
                    if (
                        myVideoRefTap.current &&
                        myVideoRefTap.current.children[0] !== undefined &&
                        myVideoRefTap.current.children[0].children[0] !== undefined &&
                        myVideoRefTap.current.children[0].children[0].tagName === 'VIDEO'
                    ) {
                        let myVideo = myVideoRef.current.children[0].children[0];
                        myVideo.currentTime = myVideoTime;
                        let myVideoTap = myVideoRefTap.current.children[0].children[0];
                        myVideoTap.currentTime = myVideoTime;
                    } else {
                        let myVideo = myVideoRef.current.children[0].children[0];
                        myVideo.currentTime = myVideoTime;
                    }
                }
                if (
                    myVideoRefBackground.current &&
                    myVideoRefBackground.current.children[0] !== undefined &&
                    myVideoRefBackground.current.children[0].children[0] !== undefined &&
                    myVideoRefBackground.current.children[0].children[0].tagName === 'VIDEO'
                ) {
                    let myVideo = myVideoRefBackground.current.children[0].children[0];
                    myVideo.currentTime = myVideoTime;
                }
            }
        }
    }, [isMade, espotBackground, espotBackgroundTreatment]);

    useEffect(() => {
        setTimeout(() => {
            if (
                myVideoRef.current &&
                myVideoRef.current.children[0] !== undefined &&
                myVideoRef.current.children[0].children[0] !== undefined &&
                myVideoRef.current.children[0].children[0].tagName === 'VIDEO'
            ) {
                if (
                    myVideoRefTap.current &&
                    myVideoRefTap.current.children[0] !== undefined &&
                    myVideoRefTap.current.children[0].children[0] !== undefined &&
                    myVideoRefTap.current.children[0].children[0].tagName === 'VIDEO'
                ) {
                    let myVideo = myVideoRef.current.children[0].children[0];
                    let myVideoTap = myVideoRefTap.current.children[0].children[0];
                    dispatch(
                        setMyVideoTime(myVideoRef.current.children[0].children[0].currentTime)
                    );
                    if (myVideo.paused && myVideoTap.paused) {
                        myVideoTap.currentTime = myVideoTime;
                        myVideo.play();
                        myVideoTap.play();
                    }
                }
            }
        }, 1500);
    }, [isMade, espotBackgroundTap, espotBackgroundTreatmentTap]);

    const fullScreenVideo = () => {
        dispatch(setFullscreen(!fullscreen));
    };

    const playPauseVideo = () => {
        if (
            myVideoRef.current &&
            myVideoRef.current.children[0].children[0] !== undefined &&
            myVideoRef.current.children[0].children[0].tagName === 'VIDEO'
        ) {
            if (
                myVideoRefTap.current &&
                myVideoRefTap.current.children[0] &&
                myVideoRefTap.current.children[0].children[0] !== undefined &&
                myVideoRefTap.current.children[0].children[0].tagName === 'VIDEO'
            ) {
                let myVideoTap = myVideoRefTap.current.children[0].children[0];
                let myVideo = myVideoRef.current.children[0].children[0];

                if (
                    (myVideoTap.paused || myVideoTap.currentTime === myVideoTap.duration) &&
                    (myVideo.paused || myVideo.currentTime === myVideo.duration)
                ) {
                    myVideoTap.play();
                    myVideo.play();
                } else {
                    myVideoTap.pause();
                    myVideo.pause();
                }
            } else {
                let myVideo = myVideoRef.current.children[0].children[0];

                if (myVideo.paused || myVideo.currentTime === myVideo.duration) {
                    myVideo.play();
                } else {
                    myVideo.pause();
                }
            }

            if (
                myVideoRefBackground.current &&
                myVideoRefBackground.current.children[0] !== undefined &&
                myVideoRefBackground.current.children[0].children[0] !== undefined &&
                myVideoRefBackground.current.children[0].children[0].tagName === 'VIDEO'
            ) {
                let myVideoBack = myVideoRefBackground.current.children[0].children[0];
                if (myVideoBack.paused || myVideoBack.currentTime === myVideoBack.duration) {
                    myVideoBack.play();
                } else {
                    myVideoBack.pause();
                }
            }
        }
    };

    const videoEnded = () => {
        dispatch(setControlVideo(false));
    };

    const videoStart = () => {
        if (
            myVideoRefBackground.current &&
            myVideoRefBackground.current.children[0] !== undefined &&
            myVideoRefBackground.current.children[0].children[0] !== undefined &&
            myVideoRefBackground.current.children[0].children[0].tagName === 'VIDEO'
        ) {
            let myVideoBack = myVideoRefBackground.current.children[0].children[0];
            setTimeout(() => myVideoBack.play(), 100);
        }
        if (
            myVideoRef.current &&
            myVideoRef.current.children[0] &&
            myVideoRef.current.children[0].children[0] !== undefined &&
            myVideoRef.current.children[0].children[0].tagName === 'VIDEO' &&
            !myVideoRef.current.children[0].children[0].paused &&
            myVideoRef.current.children[0].children[0].currentTime !==
                myVideoRef.current.children[0].children[0].duration &&
            myVideoTime &&
            controlVideo !== null
        )
            dispatch(setControlVideo(true));
    };

    const timeUpdate = () => {
        if (
            myVideoRef &&
            myVideoRef.current &&
            myVideoRef.current.children[0] &&
            myVideoRef.current.children[0].children[0] !== undefined &&
            myVideoRef.current.children[0].children[0].tagName === 'VIDEO' &&
            !myVideoRef.current.children[0].children[0].paused
        ) {
            let myVideo = myVideoRef.current.children[0].children[0];
            let duration = myVideo.duration;
            let currentTime = myVideo.currentTime;
            if (
                currentTime > 4.9 &&
                isFirstVideo &&
                first &&
                !myVideoTime &&
                document.getElementsByClassName('display-none').length === 0
            ) {
                first = false;
                playPauseVideo();
                dispatch(setFiveSecond(true));
            }
            let percentage = (100 / duration) * currentTime;
            dispatch(setPercentageProgress(percentage));
        }
    };

    const playVideoAndControl = () => {
        playPauseVideo();
        dispatch(setFiveSecond(false));
        dispatch(setControlVideo(true));
    };

    const changeVideo = () => {
        dispatch(setTapAndHold(null));
        dispatch(setIsMade(!isMade));
        dispatch(setControlVideo(null));
        dispatch(setFiveSecond(false));
    };

    const pauseVideoControl = () => {
        playPauseVideo();
        dispatch(setControlVideo(!controlVideo));
    };

    const start = () => {
        if (!fiveSecond) {
            if (controlVideo == null) dispatch(setControlVideo(true));
            dispatch(setFiveSecond(false));
        }

        dispatch(setTapAndHold(true));
        let element = document.getElementById('tap-area');

        element.addEventListener('mouseleave', () => {
            dispatch(setTapAndHold(false));
        });

        if (isMobile) {
            document.addEventListener(
                'touchmove',
                function (event) {
                    //event.preventDefault();
                    let touch = event.touches[0];
                    element = document.getElementById('tap-area');
                    let elementRect = element.getBoundingClientRect();
                    // get current width
                    let w = elementRect.width;
                    // get current height
                    let h = elementRect.height;

                    // get values on x axis
                    const x = event.touches[0].pageX - elementRect.left; // to start the value from 0 (remove offsetleft)
                    // get values on y axis
                    const y = event.touches[0].pageY - elementRect.top; // to start the value from 0 (remove offsettop)

                    //! INFO
                    // the box width range starts from [0 : w]
                    // the box height range starts from [0 : h]
                    let cursor = document.getElementById('customPointer');
                    let elementRectTotal = document
                        .getElementById('learn-more-modal')
                        .getBoundingClientRect();
                    if (cursor) {
                        const xCursor = touch.pageX - elementRectTotal.left - 25;
                        const yCursor = touch.pageY - elementRectTotal.top - 25;
                        cursor.style.top = yCursor + 'px';
                        cursor.style.left = xCursor + 'px';
                    }

                    // if X values between [0 , w] and Y values between [0 , h] then we inside the box | other than that then we left the box
                    if (!(x >= 0 && x <= w && y >= 0 && y <= h)) {
                        dispatch(setTapAndHold(false));
                    }
                },
                false
            );

            document.addEventListener('touchstart', function (event) {
                let touch = event.touches[0];
                let cursor = document.getElementById('customPointer');
                if (document.getElementById('learn-more-modal')) {
                    let elementRectTotal = document
                        .getElementById('learn-more-modal')
                        .getBoundingClientRect();
                    if (cursor) {
                        const xCursor = touch.pageX - elementRectTotal.left - 25;
                        const yCursor = touch.pageY - elementRectTotal.top - 25;
                        cursor.style.top = yCursor + 'px';
                        cursor.style.left = xCursor + 'px';
                    }
                }
            });
        }
    };

    const end = () => {
        dispatch(setTapAndHold(false));
    };

    if (!props.isOpen) return null;
    return (
        <div
            id="learn-more-modal"
            className={
                'learn-more-modal' +
                (fiveSecond &&
                !(
                    (isMade && espotBackgroundTap != null) ||
                    (!isMade && espotBackgroundTreatmentTap != null)
                )
                    ? ' background-blur'
                    : '')
            }
        >
            <span id="customPointer" className={!tapAndHold ? 'opacity-0' : ''}></span>
            {myVideoTime && <div dangerouslySetInnerHTML={{ __html: contentOnLoad }}></div>}
            {espotBackgroundVideo && (
                <div
                    className="background-learn-more-skeleton background-blur"
                    ref={myVideoRefBackground}
                    dangerouslySetInnerHTML={{ __html: espotBackgroundVideo }}
                />
            )}
            {isMade || espotBackgroundTreatment === null ? (
                <>
                    <div
                        className={tapAndHold ? 'opacity-0' : ''}
                        ref={myVideoRef}
                        dangerouslySetInnerHTML={{ __html: espotBackground }}
                    />
                    <div
                        className={!tapAndHold ? 'opacity-0' : ''}
                        ref={myVideoRefTap}
                        dangerouslySetInnerHTML={{ __html: espotBackgroundTap }}
                    />
                </>
            ) : (
                <>
                    <div
                        className={tapAndHold ? 'opacity-0' : ''}
                        ref={myVideoRef}
                        dangerouslySetInnerHTML={{ __html: espotBackgroundTreatment }}
                    />
                    <div
                        className={!tapAndHold ? 'opacity-0' : ''}
                        ref={myVideoRefTap}
                        dangerouslySetInnerHTML={{ __html: espotBackgroundTreatmentTap }}
                    />
                </>
            )}
            {fiveSecond && espotBackgroundTreatment !== null ? (
                <>
                    {(isMade && espotBackgroundTap != null) ||
                    (!isMade && espotBackgroundTreatmentTap != null) ? (
                        <div
                            tabIndex="0"
                            className="continue-video-tap cursor-hand"
                            onClick={playVideoAndControl}
                        >
                            <Image
                                imageClass="play-icon"
                                url={baseURLs.projectImage}
                                fileName="play-tap"
                            />
                        </div>
                    ) : (
                        <>
                            <div
                                tabIndex="0"
                                className="continue-video cursor-hand"
                                onClick={playVideoAndControl}
                            >
                                <Image
                                    imageClass="play-icon"
                                    url={baseURLs.projectImage}
                                    fileName="play-video"
                                />
                                <span className="continue-watching">{labels.continueWatching}</span>
                            </div>
                        </>
                    )}
                </>
            ) : null}
            {tapAndHold !== null ? <div className="display-none"></div> : null}
            <div className={'button-row' + (fullscreen ? ' opacity-0' : '')}>
                <div className="button-left">
                    {!isMade ? (
                        <>
                            {espotBackground != null &&
                            espotBackgroundTreatment !== null &&
                            espotBackgroundTreatment !== '' ? ( //TODO trovare un metodo più intelligente?
                                <GenericButton
                                    className="fill-button-treatment"
                                    handleClick={changeVideo}
                                    dataElementId={
                                        'X_X_LensPanel_' +
                                        labels.stepAnalyticsName[currentStep] +
                                        '-LearnMoreVideoTreatment'
                                    }
                                >
                                    {labels.seeTreatment}
                                </GenericButton>
                            ) : null}
                        </>
                    ) : (
                        <>
                            {espotBackground != null &&
                            espotBackgroundTreatment !== null &&
                            espotBackgroundTreatment !== '' ? (
                                <GenericButton
                                    className="fill-button-made"
                                    handleClick={changeVideo}
                                    dataElementId={
                                        'X_X_LensPanel_' +
                                        labels.stepAnalyticsName[currentStep] +
                                        '-LearnMoreVideoMade'
                                    }
                                >
                                    {labels.seeHowMade}
                                </GenericButton>
                            ) : null}
                        </>
                    )}
                </div>
                <div className="button-right">
                    {props.config && props.config.brand == 'costa' ? (
                        <a
                            tabIndex="0"
                            className="learn-more-close-link"
                            onClick={props.closeModal}
                            dataElementId={
                                'X_X_LensPanel_' +
                                labels.stepAnalyticsName[currentStep] +
                                '-LearnMoreClose'
                            }
                        >
                            X {labels.close}
                        </a>
                    ) : (
                        <GenericButton
                            tabIndex="0"
                            className="border-button border-button-close"
                            handleClick={props.closeModal}
                            dataElementId={
                                'X_X_LensPanel_' +
                                labels.stepAnalyticsName[currentStep] +
                                '-LearnMoreClose'
                            }
                        >
                            <span className="close-label">{labels.close}</span>
                            <span className="icon-close-image"></span>
                        </GenericButton>
                    )}
                </div>
            </div>
            <div className={'container-learn-more' + (fullscreen ? ' height-100' : '')}>
                {(isMade && espotBackgroundTap != null) ||
                (!isMade && espotBackgroundTreatmentTap != null) ? (
                    <div
                        id="tap-area"
                        className={'tap-area' + (tapAndHold ? ' tap-area-clicked' : '')}
                    >
                        <ClickNHold
                            time={0.2}
                            onClickNHold={start}
                            onEnd={end}
                            className="container-filling"
                        >
                            <div className="container-filling"></div>
                        </ClickNHold>
                    </div>
                ) : null}
                {!fiveSecond && controlVideo !== null ? (
                    <div
                        className={
                            isMobile
                                ? 'controls-video-mobile' + (fullscreen ? ' margin-bottom-100' : '')
                                : 'controls-video'
                        }
                    >
                        {!controlVideo ? (
                            <Image
                                imageClass="play-icon-control"
                                url={baseURLs.projectImage}
                                fileName="play-video"
                                handleClick={pauseVideoControl}
                            />
                        ) : (
                            <Image
                                imageClass="pause-icon-control"
                                url={baseURLs.projectImage}
                                fileName="pause-video"
                                handleClick={pauseVideoControl}
                            />
                        )}
                        <div
                            className={
                                'default-bar' +
                                (fullscreen ||
                                (isMade && espotBackgroundTap != null) ||
                                (!isMade && espotBackgroundTreatmentTap != null)
                                    ? ' opacity-0'
                                    : '')
                            }
                        >
                            <div
                                className="progress-bar"
                                style={{ width: percentageProgress + '%' }}
                            ></div>
                        </div>
                        {isMobile && (
                            <>
                                {fullscreen ? (
                                    <Image
                                        imageClass="fullscreen-icon-control"
                                        url={baseURLs.projectImage}
                                        fileName="full-size-ext"
                                        handleClick={fullScreenVideo}
                                    />
                                ) : (
                                    <Image
                                        imageClass="fullscreen-icon-control"
                                        url={baseURLs.projectImage}
                                        fileName="full-size"
                                        handleClick={fullScreenVideo}
                                    />
                                )}
                            </>
                        )}
                    </div>
                ) : null}
                <div
                    id="learnMoreModalStepContainer"
                    className={
                        'step-container learn-more-step-container' +
                        (props.treatmentType ? ' learn-more-step-container-treatment' : '') +
                        (fullscreen ? ' hide-element' : '')
                    }
                >
                    <div className="step-inner-container learn-more-step-inner-container">
                        <div className="learn-more-desktop">
                            {props.step !== 'treatments' ? (
                                <Step
                                    key={props.step}
                                    id={props.step}
                                    isOpen={true}
                                    hasLearnMore={false}
                                    isLearnMore={true}
                                >
                                    {props.renderStepContent(true)}
                                </Step>
                            ) : (
                                <TreatmentStep
                                    config={props.config}
                                    isOpen={true}
                                    isConfirmed={false}
                                    confirmedSelection={false}
                                    isLearnMore={true}
                                    showOnly={props.treatmentGroup}
                                    firstLearnMoreTreatment={firstLearnMoreTreatment}
                                    isMobile={false}
                                    handleUpdateTotalPriceAndDiscount={currentPackage => {
                                        props.handleUpdateTotalPriceAndDiscount(currentPackage);
                                    }}
                                    settings={settings}
                                />
                            )}
                        </div>
                        <div className="learn-more-mobile">
                            {props.step !== 'treatments' ? (
                                <Step
                                    key={props.step}
                                    id={props.step}
                                    isOpen={true}
                                    hasLearnMore={false}
                                    isLearnMore={true}
                                >
                                    <Slider {...settings}>{props.renderStepContent(true)}</Slider>
                                </Step>
                            ) : (
                                <TreatmentStep
                                    config={props.config}
                                    isOpen={true}
                                    isConfirmed={false}
                                    confirmedSelection={false}
                                    isLearnMore={true}
                                    showOnly={props.treatmentType}
                                    firstLearnMoreTreatment={firstLearnMoreTreatmentMobile}
                                    isMobile={true}
                                    handleUpdateTotalPriceAndDiscount={currentPackage => {
                                        props.handleUpdateTotalPriceAndDiscount(currentPackage);
                                    }}
                                    settings={settings}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LearnMoreModal;
